import * as tslib_1 from "tslib";
import { JobMatchesQueryFilter } from "../../../../models/jobMatchesQueryFilter";
import { CandidatesInfiniteScrollContainer } from "./candidates-infinite-scroll-container";
import * as CandidateSendOutreachEmailModal from 'raw-loader!src/app/public/app/partials/missioncontrol/candidateJobMatchesWorkflow/candidateJobMatchesWorkflow/candidateJobMatchCard/candidate-send-outreach-email-modal.html';
import { FormalizeCompany, FormalizeRequisition, FormalizeJobMatch } from "src/app/public/app/models/formalizePayload";
var CandidateJobMatchesWorkflowController = /** @class */ (function () {
    /*@ngInject*/
    function CandidateJobMatchesWorkflowController($rootScope, $state, $uibModal, $timeout, assessmentService, jobMatchDragAndDropService, requisitionService, companyService, jobMatchService, jobService, planService, webSocketsService, userRoleService, alertsAndNotificationsService, debounceService, browserService, candidateService, utilityService, outreachService, stateManagementStorageService) {
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.$uibModal = $uibModal;
        this.$timeout = $timeout;
        this.assessmentService = assessmentService;
        this.jobMatchDragAndDropService = jobMatchDragAndDropService;
        this.requisitionService = requisitionService;
        this.companyService = companyService;
        this.jobMatchService = jobMatchService;
        this.jobService = jobService;
        this.planService = planService;
        this.webSocketsService = webSocketsService;
        this.userRoleService = userRoleService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
        this.debounceService = debounceService;
        this.browserService = browserService;
        this.candidateService = candidateService;
        this.utilityService = utilityService;
        this.outreachService = outreachService;
        this.stateManagementStorageService = stateManagementStorageService;
    }
    CandidateJobMatchesWorkflowController.prototype.$onInit = function () {
        var _this = this;
        // variables
        this.companyId = this.$rootScope.userDetails.company.companyId;
        this.isCorporateFlag = this.companyService.isCorporateCompany();
        this.isStaffingFlag = this.companyService.isStaffingCompany();
        this.userId = this.$rootScope.userDetails.id;
        this.candidatesObject = {};
        this.enabledWorkflowSteps = {};
        this.workflowStepNames = [];
        this.activityMap = [];
        this.jobMatchStates = [];
        this.vendorsList = [];
        this.selectedJobMatchStates = [];
        this.selectedVendors = [];
        this.salaryDurationOptions = [];
        this.requisitionStatusesToDisableAddActions = ['Sourced', 'Paused', 'Canceled', 'Completed'];
        this.jobInfo = {};
        this.requisitionStatus = '';
        this.hiringManagersList = [];
        this.allJobMatches = [];
        this.countOfCandidatesWhoseStepHasChangedInBackground = 0;
        this.candidatesStepChangedInBackgroundMessage = "";
        this.countOfCandidatesWhoseStepHasChangedInBackground = 0;
        this.assessmentDetails == null;
        this.valueAssessmentDetails == null;
        this.displaySelectedFilterContainer = {};
        this.displaySelectedFilterContainer.searchString = "";
        this.displaySelectedFilterContainer.jobMatchStates = [];
        this.displaySelectedFilterContainer.vendors = [];
        this.displaySelectedFilterContainer.outreachStateFilters = [];
        this.savedFilters = null;
        this.savedDisplayedWorkflowSelectedFilter = null;
        var savedFilters = this.stateManagementStorageService.getScreenState("candidateWorkflowScreen-" + this.userId);
        if (savedFilters && !_.isEmpty(savedFilters)) {
            savedFilters.jobMatchIds = [];
            this.savedFilters = _.cloneDeep(savedFilters);
        }
        else {
            this.savedFilters = this.globalQueryFilterObject;
        }
        var filter = angular.copy(this.displaySelectedFilterContainer);
        var savedDisplayedWorkflowSelectedFilter = this.stateManagementStorageService.getScreenState("candidateWorkflowScreen-displayFilter-" + this.userId);
        if (savedDisplayedWorkflowSelectedFilter && !_.isEmpty(savedDisplayedWorkflowSelectedFilter)) {
            this.displaySelectedFilterContainer = _.cloneDeep(savedDisplayedWorkflowSelectedFilter);
            this.savedDisplayedWorkflowSelectedFilter = _.cloneDeep(savedDisplayedWorkflowSelectedFilter);
        }
        else {
            this.stateManagementStorageService.setScreenState("candidateWorkflowScreen-displayFilter-" + this.userId, filter);
        }
        this.candidateWorkFlowFilterItemsSelected = [];
        this.primaryHiringManager = [];
        this.endClient = null;
        this.outreachFilters = [];
        this.selectedOutreachStates = [];
        this.workflowFirstStep = "";
        //flags
        this.isFiltersChanged = false;
        this.showFilterPanel = false;
        this.isSuperUserOr4dot5Admin = this.userRoleService.isLoggedInUserSuperUserOr4dot5Admin();
        this.showRefreshWorkFlowAction = false;
        this.hideSearchStringFlag = false;
        this.jobIntegrationEnabled = false;
        this.disableAddActionsFlag = false;
        this.disableAssignRecruiterActionsFlag = false;
        this.disableSendTechAssessmentActionsFlag = false;
        this.disableValueAssessmentActionsFlag = false;
        this.disableCancelTechAssessmentActionsFlag = false;
        this.disableCancelValueAssessmentActionsFlag = false;
        this.disableReleaseCandidatesActionsFlag = false;
        this.disableMarkAsNotInterestedActionsFlag = false;
        this.jobInfoLoadedFlag = false;
        this.isJobBoardServiceUp = true;
        this.jobMatchStatesLoadedFlag = false;
        this.showVendorFilterFlag = false;
        this.vendorsListLoadedFlag = false;
        this.showGlobalAssignRecruiterAction = true;
        this.showGlobalTechAssessmentAction = false;
        this.showGlobalCancelTechAssessmentAction = false;
        this.showGlobalValueAssessmentAction = false;
        this.showGlobalCancelValueAssessmentAction = false;
        this.enableSelectJobMatchesOptions = false;
        this.selectAllJobMatchesFlag = false;
        this.techAssessmentInfoLoading = true;
        this.valueAssessmentInfoLoading = true;
        this.isTechAssessmentInfoExists = false;
        this.isValueAssessmentInfoExists = false;
        this.displayCandidateWorkFlowFilter = false;
        this.showDisplayFilterIcon = true;
        this.emptyJobMatchSelectedFilter = false;
        this.isRecruitersPopoverOpen = false;
        this.isHiringManagerPopoverOpen = false;
        this.isOutreachEnabled = false;
        this.refreshReRunScore = false;
        this.scoringInProgress = false;
        this.outreachFiltersLoadedFlag = true;
        this.jobMatchInProgress = false;
        setTimeout(function () {
            //drag scroll handling
            _this._setDragConfig();
        }, 2000);
        this.getOutreachFilters();
        this._setDebounceService();
        this._listenToWorkflowStateUpdate();
        this._listenToJobMatchRemove();
        this._getAllActivityTypes();
        this._getAllJobMatchStates();
        this._getPlanDetails();
        this._getSalaryDurationOptions(function () {
            _this._getJobDetails(function () {
                _this.requisitionStatus = _this.jobInfo.requisitionStatus;
                if (_this.jobInfo.hiringManagerDetails && _this.jobInfo.hiringManagerDetails.length > 0) {
                    if (_this.jobInfo.hiringManagerDetails.length == 1) {
                        _this.primaryHiringManager = _this.jobInfo.hiringManagerDetails;
                    }
                    else {
                        _this.jobInfo.hiringManagerDetails.map(function (hiringManager) {
                            if (hiringManager.isPrimary || hiringManager.isPoc) {
                                _this.primaryHiringManager.push(hiringManager);
                            }
                            else {
                                _this.hiringManagersList.push(hiringManager);
                            }
                        });
                    }
                    if (_this.primaryHiringManager.length == 0) {
                        _this.primaryHiringManager = _this.hiringManagersList.slice(1);
                    }
                }
                _this.pointOfContact = _this.jobInfo.pointOfContact;
                _this.endClient = _this.jobInfo.endClient ? _this.jobInfo.endClient.name : _this.jobInfo.endClient;
                if (_this.requisitionStatusesToDisableAddActions.indexOf(_this.requisitionStatus) != -1) {
                    _this.disableAddActionsFlag = true;
                }
                if (_this.isCorporateFlag && _this.jobInfo.sharedRequisition) {
                    // do not show assign recruiter global action
                    _this.showGlobalAssignRecruiterAction = false;
                    // show the vendors filter
                    _this.showVendorFilterFlag = true;
                    _this._getVendors();
                }
                if (_this.jobId != '') {
                    _this.getEnabledWorkflowSteps(function () {
                        angular.forEach(_this.enabledWorkflowSteps, function (val, key) {
                            if (val == 'Tech Assessment') {
                                _this.showGlobalTechAssessmentAction = true;
                                _this.showGlobalCancelTechAssessmentAction = true;
                            }
                            else if (val == 'Value Assessment') {
                                _this.showGlobalValueAssessmentAction = true;
                                _this.showGlobalCancelValueAssessmentAction = true;
                            }
                        });
                        _this._createCandidatesObject();
                        // _getAllJobMatches();
                    });
                }
                else {
                    _this._createCandidatesObject();
                }
                // $(window).bind('resize', _setCandidateStateWrapperColumnContainerHeight);
                // catch the event to refresh the workflow
                _this.$rootScope.$on('refreshJobWorkflow', function (event, data) {
                    _this.resetCandidateJobMatches();
                });
                // $("#candidateJobMatchesWorkflowSearchText").keyup(this.debounceService.debounce(this.queryJobMatches, 500));
                _this.jobInfo.listOfAllRecruitersAndHiringManagers = tslib_1.__spread(_this.jobInfo.allRecruitersList, _this.hiringManagersList, _this.primaryHiringManager);
                if (_this.pointOfContact) {
                    _this.jobInfo.listOfAllRecruitersAndHiringManagers = _this.jobInfo.listOfAllRecruitersAndHiringManagers.filter(function (user) { return user.name != _this.pointOfContact; });
                    _this.jobInfo.listOfAllRecruitersAndHiringManagers.push({ name: _this.pointOfContact });
                }
            });
        });
        this._checkJobBoardsSearchAvailability();
        $(document).ready(function () {
            $("#workflow-search-panel").hide();
            $(document).off("click", "#open-filter").on("click", "#open-filter", function () {
                $("#workflow-search-panel").animate({
                    height: 'toggle'
                });
                _this.showFilterPanel = !_this.showFilterPanel;
            });
        });
        this.getAllPreferredJobTypes();
        this._checkIfOutreachEnabled();
        this.getJobScoringJobStatus();
    };
    CandidateJobMatchesWorkflowController.prototype.getJobScoringJobStatus = function () {
        var _this = this;
        this.jobService.getJobScoringJobStatus(this.jobId, function (data) {
            _this.scoringInProgress = data;
            if (_this.scoringInProgress) {
                var message = "Job matching is in progress. You will be notified once it's completed...";
                _this.alertsAndNotificationsService.showAlertWithCallBack("Job matching in Progress", message, "success", function () {
                    _this.$state.go('missioncontrol.requisitions');
                });
            }
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    CandidateJobMatchesWorkflowController.prototype._checkTechAssessmentIdExists = function () {
        if (this.jobInfo.techAssessmentId) {
            this.isTechAssessmentInfoExists = true;
        }
    };
    CandidateJobMatchesWorkflowController.prototype._getAssessmentDetails = function () {
        var _this = this;
        if (this.assessmentDetails == null) {
            this.assessmentService.getAssessmentDetails(this.jobInfo.techAssessmentId, this.jobId, function (data) {
                _this.assessmentDetails = data;
                _this._setTotalDuration();
                _this.techAssessmentInfoLoading = false;
            }, function (error) {
                // this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            });
        }
    };
    CandidateJobMatchesWorkflowController.prototype._setTotalDuration = function () {
        var _this = this;
        this.assessmentDetails.totalDuration = 0;
        angular.forEach(this.assessmentDetails.sections, function (section, key) {
            _this.assessmentDetails.totalDuration = _this.assessmentDetails.totalDuration + section.duration;
        });
    };
    CandidateJobMatchesWorkflowController.prototype._checkValueAssessmentIdExists = function () {
        if (this.jobInfo.valueAssessmentId) {
            this.isValueAssessmentInfoExists = true;
        }
    };
    CandidateJobMatchesWorkflowController.prototype._getValueAssessmentDetails = function () {
        var _this = this;
        if (this.jobInfo.valueAssessmentId != null && this.valueAssessmentDetails == null) {
            this.assessmentService.getAssessmentDetails(this.jobInfo.valueAssessmentId, this.jobId, function (data) {
                _this.valueAssessmentDetails = data;
                _this._setValueAssessmentDuration();
                _this.valueAssessmentInfoLoading = false;
            }, function (error) {
                // this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            });
        }
    };
    CandidateJobMatchesWorkflowController.prototype._setValueAssessmentDuration = function () {
        var _this = this;
        this.valueAssessmentDetails.totalDuration = 0;
        angular.forEach(this.valueAssessmentDetails.sections, function (section, key) {
            _this.valueAssessmentDetails.totalDuration = _this.valueAssessmentDetails.totalDuration + section.duration;
        });
    };
    CandidateJobMatchesWorkflowController.prototype._massageRequisitionCardInfo = function (data) {
        var massagedRequisitionInfo = this.requisitionService.massageRequisitionCardInfo(data, this.salaryDurationOptions);
        angular.merge(this.jobInfo, massagedRequisitionInfo.data);
    };
    CandidateJobMatchesWorkflowController.prototype.onGlobalFilterChange = function () {
        this.isFiltersChanged = true;
        if (!this.showFilterPanel) {
            $("#workflow-search-panel").animate({
                height: 'toggle'
            });
            this.showFilterPanel = true;
        }
        if (this._onEnterKeyPress(event)) {
            this.queryJobMatches();
        }
    };
    CandidateJobMatchesWorkflowController.prototype._onEnterKeyPress = function (event) {
        return event && event.keyCode == 13;
    };
    CandidateJobMatchesWorkflowController.prototype._setDragConfig = function () {
        var _this = this;
        this.container = $('#steps-container');
        this.offset = this.container.offset();
        this.offsetWidth = this.offset.left + this.container.width();
        this.offsetHeight = this.offset.top + this.container.height();
        this.draggableCard = $('.draggable-card');
        this.intRightHandler = null;
        this.intLeftHandler = null;
        this.intTopHandler = null;
        this.intBottomHandler = null;
        this.distance = 250;
        this.timer = 40;
        this.step = 50;
        if (this.browserService.isGoogleChrome()) {
            $('#steps-container').bind("drag", function (e) {
                // $('.row-horizon').bind("drag", (e) => {
                _this._drag(e);
            });
        }
    };
    CandidateJobMatchesWorkflowController.prototype._setDebounceService = function () {
        this.queryJobMatches = _.debounce(this.queryJobMatches, 500);
    };
    CandidateJobMatchesWorkflowController.prototype._listenToWorkflowStateUpdate = function () {
        var _this = this;
        this.webSocketsService.receiveWorkflowUpdate().then(null, null, function (stateChange) {
            if (_this.jobId == stateChange.reqId) {
                _this.jobMatchInProgress = stateChange.jobMatchInProgress;
            }
            if (stateChange.refreshWorkflow && _this.jobId == stateChange.reqId) {
                if (stateChange.reRunScoringDone) {
                    // After Re Run Scoring is done. Show re run score refresh message, if 'jobMatchId' is received as null.
                    _this.showRefreshWorkFlowAction = true;
                    _this.refreshReRunScore = true;
                    _this.candidatesStepChangedInBackgroundMessage = "Re-run for candidates in workflow done.";
                }
                else {
                    if (!stateChange.jobMatchInProgress) {
                        _this.showRefreshWorkFlowAction = true;
                        _this.refreshReRunScore = false;
                        _this.countOfCandidatesWhoseStepHasChangedInBackground++;
                        if (_this.countOfCandidatesWhoseStepHasChangedInBackground == 1) {
                            _this.candidatesStepChangedInBackgroundMessage = " Card updated.";
                        }
                        else {
                            _this.candidatesStepChangedInBackgroundMessage = " Cards updated.";
                        }
                    }
                }
            }
            _this.$rootScope.$emit("REFRESH_JOB_MATCH_CARD", stateChange);
        });
    };
    CandidateJobMatchesWorkflowController.prototype._listenToJobMatchRemove = function () {
        var _this = this;
        this.removeJobMatchListener = this.$rootScope.$on("REMOVE_JOB_MATCH_CARD", function (event, jobMatch) {
            _this.resetCandidateJobMatches();
            var candidateName = jobMatch.firstName;
            if (jobMatch.lastName) {
                candidateName += ' ' + jobMatch.lastName;
            }
            var message = candidateName + " has been removed as the candidate no longer matches the job requirements";
            _this.alertsAndNotificationsService.showAlert("Job Match Removed", message, "warning");
        });
    };
    CandidateJobMatchesWorkflowController.prototype._getAllActivityTypes = function () {
        var _this = this;
        this.jobService.getActivityTypes(function (data) {
            _this.activityMap = [];
            angular.forEach(data, function (val, key) {
                _this.activityMap[val.value] = val.name;
            });
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    CandidateJobMatchesWorkflowController.prototype._getAllJobMatchStates = function () {
        var _this = this;
        this.jobMatchStatesLoadedFlag = false;
        this.jobMatchService.getAllJobMatchStates(function (data) {
            angular.forEach(data.candidateWorkflowCardStatus, function (stepVal, stepKey) {
                var stepEntry = {};
                stepEntry.name = stepVal.status;
                stepEntry.value = stepVal.status;
                if (stepVal.status === 'No longer a match') {
                    stepEntry.label = "<span style='color: #e84e40; font-weight: bold;'>" + stepVal.status + "</span>";
                }
                else {
                    stepEntry.label = "<b>" + stepVal.status + "</b>";
                }
                stepEntry.stepGroup = true;
                _this.jobMatchStates.push(stepEntry);
                angular.forEach(stepVal.states, function (stateVal, stateKey) {
                    var stateEntry = {};
                    stateEntry.name = stateVal;
                    stateEntry.value = stateVal;
                    if (stateVal === 'No longer a match') {
                        stateEntry.label = "<span style='color: #e84e40;'>" + stateVal + "</span>";
                    }
                    else {
                        stateEntry.label = stateVal;
                    }
                    stateEntry.ticked = false;
                    _this.jobMatchStates.push(stateEntry);
                });
                stepEntry = {};
                stepEntry.stepGroup = false;
                _this.jobMatchStates.push(stepEntry);
            });
            _this.jobMatchStatesLoadedFlag = true;
            if (_this.savedFilters && _this.savedFilters.workflowStates && _this.savedFilters.workflowStates.length > 0) {
                _this.selectedJobMatchStates = _this.jobMatchStates.filter(function (jobMatch) { return jobMatch.value && !jobMatch.stepGroup && _this.savedFilters.workflowStates.some(function (selected) { return selected == jobMatch.value; }); });
                _this.selectedJobMatchStates.forEach(function (state) { return state.ticked = true; });
                _this.globalQueryFilterObject.workflowStates = _this.selectedJobMatchStates.map(function (val, index) {
                    return val.value;
                });
            }
            if (_this.savedDisplayedWorkflowSelectedFilter && _this.savedDisplayedWorkflowSelectedFilter.jobMatchStates && _this.savedDisplayedWorkflowSelectedFilter.jobMatchStates.length !== 0) {
                _this.displaySelectedFilterContainer.jobMatchStates = [];
                _this.displaySelectedFilterContainer.jobMatchStates = _this.selectedJobMatchStates.map(function (val, index) {
                    return val.value;
                });
                _this.setSelectedFilterItems(_this.displaySelectedFilterContainer);
            }
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    CandidateJobMatchesWorkflowController.prototype._getPlanDetails = function () {
        var _this = this;
        this.planService.getCompanyPlanDetails(this.companyId, function (data) {
            if (!_.isNull(data) && typeof data === 'object' && !_.isNull(data.features) && data.features.length) {
                var jobIntegrationDetails = _.find(data.features, { 'name': "Job Board Integration", 'available': true });
                _this.jobIntegrationEnabled = _.isUndefined(jobIntegrationDetails) ? false : true;
            }
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    CandidateJobMatchesWorkflowController.prototype._getSalaryDurationOptions = function (successCallback) {
        var _this = this;
        this.jobService.getSalaryDurationOptions(function (data) {
            _this.salaryDurationOptions = data;
            if (successCallback) {
                successCallback();
            }
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    CandidateJobMatchesWorkflowController.prototype._getJobDetails = function (successCallback) {
        var _this = this;
        this.jobInfoLoadedFlag = false;
        this.jobService.getRequisitionDetails(this.jobId, this.companyId, function (data) {
            angular.merge(_this.jobInfo, data);
            _this._massageRequisitionCardInfo(_this.jobInfo);
            _this._checkTechAssessmentIdExists();
            _this._checkValueAssessmentIdExists();
            _this.headerInfo = _this._getHeaderInfo();
            var headerDetailsList = _this.headerInfo.split("@");
            if (headerDetailsList && headerDetailsList.length > 0) {
                _this.companyLabel = headerDetailsList[0];
                if (headerDetailsList.length > 1) {
                    _this.locationLabel = headerDetailsList[1];
                }
            }
            else {
                _this.companyLabel = _this.headerInfo;
            }
            _this.jobInfoLoadedFlag = true;
            _this._setGlobalActionsPermission();
            _this.jobMatchInProgress = data.jobMatchInProgress;
            if (successCallback) {
                successCallback();
            }
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    CandidateJobMatchesWorkflowController.prototype._getHeaderInfo = function () {
        var info = this.jobService.getJobLocationInfoText(this.jobInfo, this.isCorporateFlag);
        this.jobLocation = info.jobLocation;
        return info.headerInfo;
    };
    CandidateJobMatchesWorkflowController.prototype._setGlobalActionsPermission = function () {
        if (this.jobInfo.requisitionStatus == 'Paused' || this.jobInfo.requisitionStatus == 'Canceled') {
            this.disableAssignRecruiterActionsFlag = true;
            this.disableSendTechAssessmentActionsFlag = true;
            this.disableValueAssessmentActionsFlag = true;
            this.disableCancelTechAssessmentActionsFlag = true;
            this.disableCancelValueAssessmentActionsFlag = true;
            this.disableReleaseCandidatesActionsFlag = true;
            this.disableMarkAsNotInterestedActionsFlag = true;
        }
    };
    CandidateJobMatchesWorkflowController.prototype._getVendors = function () {
        var _this = this;
        this.vendorsListLoadedFlag = false;
        this.jobService.getAssignedVendors(this.jobId, function (data) {
            _this.vendorsList = data;
            if (_this.savedFilters && _this.savedFilters.vendors && _this.savedFilters.vendors.length > 0) {
                _this.selectedVendors = _this.vendorsList.filter(function (vendor) { return _this.savedFilters.vendors.some(function (selected) { return selected == vendor.vendorId; }); });
                _this.selectedVendors.forEach(function (vendor) { return vendor.ticked = true; });
                _this.globalQueryFilterObject.vendors = _this.selectedVendors.map(function (val, index) {
                    return val.vendorId;
                });
            }
            if (_this.savedDisplayedWorkflowSelectedFilter && _this.savedDisplayedWorkflowSelectedFilter.vendors && _this.savedDisplayedWorkflowSelectedFilter.vendors.length !== 0) {
                _this.displaySelectedFilterContainer.vendors = [];
                _this.displaySelectedFilterContainer.vendors = _this.selectedVendors.map(function (val, index) {
                    return val.vendorName;
                });
                _this.setSelectedFilterItems(_this.displaySelectedFilterContainer);
            }
            _this.vendorsListLoadedFlag = true;
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    CandidateJobMatchesWorkflowController.prototype.getEnabledWorkflowSteps = function (successCallback) {
        var _this = this;
        this.jobService.getEnabledWorkflowSteps(this.jobId, function (data) {
            _this.enabledWorkflowSteps = data;
            _this.workflowStepNames = [];
            angular.forEach(_this.enabledWorkflowSteps, function (stepName, key) {
                _this.workflowStepNames.push(stepName);
            });
            if (successCallback) {
                successCallback();
            }
        }, function (error) {
            if (_this.$rootScope.isOnline) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    };
    CandidateJobMatchesWorkflowController.prototype._createCandidatesObject = function () {
        var _this = this;
        this.candidatesObject = {};
        if (this.jobId != '') {
            angular.forEach(this.enabledWorkflowSteps, function (val, key) {
                var tempVal = val;
                var infoVariableStringArray = tempVal.split(" ");
                var infoVariableString = '';
                var identifierString = '';
                if (infoVariableStringArray.length > 1) {
                    infoVariableString = infoVariableStringArray[0].toLowerCase() + infoVariableStringArray[1] + 'Info';
                    identifierString = infoVariableStringArray[0].toLowerCase() + '-' + infoVariableStringArray[1].toLowerCase();
                }
                else {
                    infoVariableString = infoVariableStringArray[0].toLowerCase() + 'Info';
                    identifierString = infoVariableStringArray[0].toLowerCase();
                }
                _this.candidatesObject[infoVariableString] = new CandidatesInfiniteScrollContainer(val, infoVariableString, identifierString, _this.userId, _this.companyId, _this.jobId, _this.globalQueryFilterObject, _this.workflowStepNames, _this.jobMatchDragAndDropService, _this.jobMatchService, _this.alertsAndNotificationsService);
            });
        }
        else {
            this.candidatesObject = {
                recruiterScreeningInfo: new CandidatesInfiniteScrollContainer('Recruiter Screening', 'recruiterScreeningInfo', 'recruiter-screening', this.userId, this.companyId, this.jobId, this.globalQueryFilterObject, this.workflowStepNames, this.jobMatchDragAndDropService, this.jobMatchService, this.alertsAndNotificationsService),
                //qualifiedInfo:  new CandidatesInfiniteScrollContainer('Qualified','qualifiedInfo','soft-qualified'),
                techAssessmentInfo: new CandidatesInfiniteScrollContainer('Tech Assessment', 'techAssessmentInfo', 'tech-assessment', this.userId, this.companyId, this.jobId, this.globalQueryFilterObject, this.workflowStepNames, this.jobMatchDragAndDropService, this.jobMatchService, this.alertsAndNotificationsService),
                valueAssessmentInfo: new CandidatesInfiniteScrollContainer('Value Assessment', 'valueAssessmentInfo', 'value-assessment', this.userId, this.companyId, this.jobId, this.globalQueryFilterObject, this.workflowStepNames, this.jobMatchDragAndDropService, this.jobMatchService, this.alertsAndNotificationsService),
                verificationInfo: new CandidatesInfiniteScrollContainer('Verification', 'verificationInfo', 'verification', this.userId, this.companyId, this.jobId, this.globalQueryFilterObject, this.workflowStepNames, this.jobMatchDragAndDropService, this.jobMatchService, this.alertsAndNotificationsService),
                phoneScreenInfo: new CandidatesInfiniteScrollContainer('Phone Screen', 'phoneScreenInfo', 'phone-screen', this.userId, this.companyId, this.jobId, this.globalQueryFilterObject, this.workflowStepNames, this.jobMatchDragAndDropService, this.jobMatchService, this.alertsAndNotificationsService),
                interviewInfo: new CandidatesInfiniteScrollContainer('Interview', 'interviewInfo', 'interview', this.userId, this.companyId, this.jobId, this.globalQueryFilterObject, this.workflowStepNames, this.jobMatchDragAndDropService, this.jobMatchService, this.alertsAndNotificationsService),
                //likelyInfo:  new CandidatesInfiniteScrollContainer('Likely','likelyInfo','soft-qualified'),
                notInterestedInfo: new CandidatesInfiniteScrollContainer('Not Interested', 'notInterestedInfo', 'not-interested', this.userId, this.companyId, this.jobId, this.globalQueryFilterObject, this.workflowStepNames, this.jobMatchDragAndDropService, this.jobMatchService, this.alertsAndNotificationsService),
                releasedInfo: new CandidatesInfiniteScrollContainer('Released', 'releasedInfo', 'released', this.userId, this.companyId, this.jobId, this.globalQueryFilterObject, this.workflowStepNames, this.jobMatchDragAndDropService, this.jobMatchService, this.alertsAndNotificationsService)
            };
        }
        this.$timeout(function () {
            _this.workflowFirstStep = Object.values(_this.candidatesObject)[0].workflowStepNames[0];
        }, 500);
    };
    CandidateJobMatchesWorkflowController.prototype.resetCandidateJobMatches = function () {
        var _this = this;
        this.showRefreshWorkFlowAction = false;
        this.refreshReRunScore = false;
        this.countOfCandidatesWhoseStepHasChangedInBackground = 0;
        this._createCandidatesObject();
        angular.forEach(this.candidatesObject, function (val, key) {
            var tempWorkflowSteps = val.jobMatchesQueryFilter.workflowSteps;
            val.jobMatchesQueryFilter = angular.copy(_this.globalQueryFilterObject);
            val.jobMatchesQueryFilter.workflowSteps = tempWorkflowSteps;
            _this._clearJobMatchIdsFilterOnAnyOtherFilterChange(val.jobMatchesQueryFilter);
            val.getNext();
        });
    };
    CandidateJobMatchesWorkflowController.prototype._clearJobMatchIdsFilterOnAnyOtherFilterChange = function (jobMatchesQueryFilter) {
        jobMatchesQueryFilter.jobMatchIds = [];
    };
    CandidateJobMatchesWorkflowController.prototype.selectAllCandidates = function () {
        var _this = this;
        this.selectAllJobMatchesFlag = true;
        var selectingAllCandidatesDialog = bootbox.dialog({
            message: '<span class="loading-message"> Selecting Candidates <i class="fa fa-spinner fa-spin"></i></span>',
            closeButton: false
        });
        this._getAllJobMatches(function () {
            angular.forEach(_this.candidatesObject, function (val, key) {
                angular.forEach(val.candidates, function (candidate, k) {
                    candidate.selectedFlag = true;
                });
            });
            selectingAllCandidatesDialog.modal('hide');
        });
    };
    CandidateJobMatchesWorkflowController.prototype._getAllJobMatches = function (successCallback) {
        var _this = this;
        var steps = [];
        angular.forEach(this.enabledWorkflowSteps, function (step, key) {
            steps.push(step);
        });
        var jobMatchesQueryFilter = angular.copy(this.globalQueryFilterObject);
        jobMatchesQueryFilter.workflowSteps = angular.copy(steps);
        this.jobMatchService.getJobMatchCandidates(this.userId, this.companyId, 1, 2000, this.jobId, jobMatchesQueryFilter, function (data) {
            _this.allJobMatches = [];
            angular.forEach(_this.enabledWorkflowSteps, function (val, key) {
                var tempVal = val;
                var infoVariableStringArray = tempVal.split(" ");
                var infoVariableString = '';
                var identifierString = '';
                if (infoVariableStringArray.length > 1) {
                    infoVariableString = infoVariableStringArray[0].toLowerCase() + infoVariableStringArray[1] + 'Info';
                }
                else {
                    infoVariableString = infoVariableStringArray[0].toLowerCase() + 'Info';
                }
                var tempJobMatches = JSON.parse(data[infoVariableString]);
                angular.forEach(tempJobMatches, function (jobMatch, key) {
                    jobMatch.selectFlag = false;
                    _this.allJobMatches.push(jobMatch);
                });
            });
            _this.enableSelectJobMatchesOptions = true;
            if (successCallback) {
                successCallback();
            }
        }, function (error) {
            if (_this.$rootScope.isOnline) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    };
    CandidateJobMatchesWorkflowController.prototype.getAllPreferredJobTypes = function () {
        var _this = this;
        this.jobService.getAllJobTypes(function (data) {
            _this.jobTypeList = data;
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    CandidateJobMatchesWorkflowController.prototype._checkIfOutreachEnabled = function () {
        // this.candidateService.getOutreachEmailEnabledStatus((data) => {
        //     this.isOutreachEnabled = data;
        // }, (error) => {
        //     this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        // });
        this.isOutreachEnabled = true;
    };
    CandidateJobMatchesWorkflowController.prototype.deSelectAllCandidates = function () {
        this.selectAllJobMatchesFlag = false;
        angular.forEach(this.candidatesObject, function (val, key) {
            angular.forEach(val.candidates, function (candidate, k) {
                candidate.selectedFlag = false;
            });
        });
    };
    CandidateJobMatchesWorkflowController.prototype._checkJobBoardsSearchAvailability = function () {
        var _this = this;
        this.jobService.checkJobBoardsSearchAvailability(function (data) {
            _this.isJobBoardServiceUp = data;
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    CandidateJobMatchesWorkflowController.prototype._setCandidateStateWrapperColumnContainerHeight = function () {
        var windowHeight = $(window).height();
        var containerHeight = windowHeight - 10;
        containerHeight = parseInt(containerHeight) + 'px';
        $(".candidate-state-wrapper-column-container").css('height', containerHeight);
    };
    CandidateJobMatchesWorkflowController.prototype.displaySelectedFilterToggle = function () {
        if (this.displayCandidateWorkFlowFilter) {
            $("#display-candidate-workflow-selected-filter-panel").animate({
                height: 'toggle'
            });
            this.showDisplayFilterIcon = !this.showDisplayFilterIcon;
        }
    };
    CandidateJobMatchesWorkflowController.prototype.addToDisplayFilters = function (event) {
        switch (event) {
            case 'search':
                this.displaySelectedFilterContainer.searchString = this.globalQueryFilterObject.searchString;
                this.setSelectedFilterItems(this.displaySelectedFilterContainer);
                break;
            default:
                break;
        }
    };
    CandidateJobMatchesWorkflowController.prototype._setObjectVariableName = function (currentObject) {
        var selectedFilterVariableNameObj = {
            jobMatchStates: "Job Match States", vendors: "Vendors", searchString: "Search", outreachStateFilters: "Outreach States"
        };
        for (var key in selectedFilterVariableNameObj) {
            if (selectedFilterVariableNameObj.hasOwnProperty(key)) {
                var obj = selectedFilterVariableNameObj[key];
                if (key == currentObject.variable) {
                    this.displaySelectedFilterObj.variable = obj;
                }
            }
        }
    };
    CandidateJobMatchesWorkflowController.prototype.isFilterValueArray = function (value) {
        if (Array.isArray(value)) {
            return true;
        }
        else {
            return false;
        }
    };
    CandidateJobMatchesWorkflowController.prototype.setSelectedFilterItems = function (filtersItemsSelected) {
        var _this = this;
        this.emptyJobMatchSelectedFilter = false;
        for (var key in filtersItemsSelected) {
            if (filtersItemsSelected.hasOwnProperty(key)) {
                var obj = filtersItemsSelected[key];
                if (obj.length > 0) {
                    this.displayCandidateWorkFlowFilter = true;
                    this.displaySelectedFilterObj = {};
                    if (this.candidateWorkFlowFilterItemsSelected.length !== 0) {
                        this.candidateWorkFlowFilterItemsSelected.forEach(function (filterItem) {
                            if (filterItem.filter == key) {
                                if (filterItem.setSelectedFilterLimit == 5) {
                                    _this.displaySelectedFilterObj = { filter: key, variable: key, value: obj, setSelectedFilterLimit: 5, expandSelectedFilter: false };
                                }
                                else {
                                    _this.displaySelectedFilterObj = { filter: key, variable: key, value: obj, setSelectedFilterLimit: obj.length, expandSelectedFilter: filterItem.expandSelectedFilter };
                                }
                            }
                        });
                    }
                    if (this.candidateWorkFlowFilterItemsSelected.length == 0 || Object.keys(this.displaySelectedFilterObj).length == 0) {
                        this.displaySelectedFilterObj = { filter: key, variable: key, value: obj, setSelectedFilterLimit: 5, expandSelectedFilter: false };
                    }
                    this._setObjectVariableName(this.displaySelectedFilterObj);
                    if (this.candidateWorkFlowFilterItemsSelected.length > 0) {
                        this.candidateWorkFlowFilterItemsSelected = this.candidateWorkFlowFilterItemsSelected.filter(function (item) { return item.variable !== _this.displaySelectedFilterObj.variable; });
                    }
                    this.candidateWorkFlowFilterItemsSelected.push(this.displaySelectedFilterObj);
                }
                else {
                    if (this.candidateWorkFlowFilterItemsSelected.length > 0) {
                        this.candidateWorkFlowFilterItemsSelected = this.candidateWorkFlowFilterItemsSelected.filter(function (item) { return item.filter !== key; });
                    }
                }
            }
        }
        if (this.candidateWorkFlowFilterItemsSelected.length === 0) {
            if (this.candidatesObject && this.candidatesObject.notInterestedInfo && !this.candidatesObject.notInterestedInfo.isFilterOn) {
                this.displayCandidateWorkFlowFilter = false;
            }
            else {
                this.emptyJobMatchSelectedFilter = true;
            }
        }
    };
    CandidateJobMatchesWorkflowController.prototype._deleteSelectedItem = function (currentObject, filtersItemsDeleted) {
        var _this = this;
        switch (currentObject.variable) {
            case 'searchString':
                this.globalQueryFilterObject.searchString = '';
                this.displaySelectedFilterContainer.searchString = '';
                this.setSelectedFilterItems(this.displaySelectedFilterContainer);
                break;
            case 'jobMatchStates':
                this.jobMatchStates.forEach(function (jobMatch, index) {
                    if (jobMatch.value === filtersItemsDeleted) {
                        jobMatch.ticked = false;
                        _this.selectedJobMatchStates = _this.selectedJobMatchStates.filter(function (item) { return item.value !== filtersItemsDeleted; });
                    }
                });
                this.onFilterItemClick('selectedClients', 'JobMatchStates');
                break;
            case 'vendors':
                this.vendorsList.forEach(function (vendor, index) {
                    if (vendor.vendorName === filtersItemsDeleted) {
                        vendor.ticked = false;
                        _this.selectedVendors = _this.selectedVendors.filter(function (item) { return item.vendorName !== filtersItemsDeleted; });
                    }
                });
                this.onFilterItemClick('selectedVendors', 'Vendors');
                break;
            case 'outreachStateFilters':
                this.outreachFilters.forEach(function (outreachState, index) {
                    if (outreachState.name === filtersItemsDeleted) {
                        outreachState.ticked = false;
                        _this.selectedOutreachStates = _this.selectedOutreachStates.filter(function (item) { return item.name !== filtersItemsDeleted; });
                    }
                });
                this.onFilterItemClick('selectedOutreachStates', 'OutreachStates');
                break;
            default:
                break;
        }
    };
    CandidateJobMatchesWorkflowController.prototype.deletedSelectedFilterItem = function (filtersItemsDeleted) {
        for (var key in this.displaySelectedFilterContainer) {
            if (this.displaySelectedFilterContainer.hasOwnProperty(key)) {
                var obj = this.displaySelectedFilterContainer[key];
                if (Array.isArray(obj)) {
                    if (obj.includes(filtersItemsDeleted)) {
                        this.deleteSelectedFilter = {};
                        this.deleteSelectedFilter = { variable: key, value: obj };
                        this._deleteSelectedItem(this.deleteSelectedFilter, filtersItemsDeleted);
                    }
                }
                else {
                    if (obj == filtersItemsDeleted) {
                        this.deleteSelectedFilter = {};
                        this.deleteSelectedFilter = { variable: key, value: obj };
                        this._deleteSelectedItem(this.deleteSelectedFilter, filtersItemsDeleted);
                    }
                }
            }
        }
    };
    CandidateJobMatchesWorkflowController.prototype.queryJobMatches = function () {
        var _this = this;
        this.isFiltersChanged = false;
        this.showRefreshWorkFlowAction = false;
        this.refreshReRunScore = false;
        this.countOfCandidatesWhoseStepHasChangedInBackground = 0;
        this._createCandidatesObject();
        angular.forEach(this.candidatesObject, function (val, key) {
            var tempWorkflowSteps = val.jobMatchesQueryFilter.workflowSteps;
            val.jobMatchesQueryFilter = angular.copy(_this.globalQueryFilterObject);
            val.jobMatchesQueryFilter.workflowSteps = tempWorkflowSteps;
            _this._clearJobMatchIdsFilterOnAnyOtherFilterChange(val.jobMatchesQueryFilter);
            val.jobMatchesQueryFilter.workflowStates = val.jobMatchesQueryFilter.workflowStates.filter(function (state) { return state; });
            val.getNext();
        });
        //get all job matches for select/deselect
        if (this.selectAllJobMatchesFlag) {
            this.selectAllCandidates();
        }
        // Hide Display Filter
        if (this.candidateWorkFlowFilterItemsSelected.length === 0) {
            this.displayCandidateWorkFlowFilter = false;
            this.showDisplayFilterIcon = true;
        }
        this.$timeout(function () {
            _this.stateManagementStorageService.setScreenState("candidateWorkflowScreen-" + _this.userId, _this.globalQueryFilterObject);
            // Display Selected Filter
            _this.stateManagementStorageService.setScreenState("candidateWorkflowScreen-displayFilter-" + _this.userId, _this.displaySelectedFilterContainer);
        }, 200);
    };
    CandidateJobMatchesWorkflowController.prototype.resetWorkflowFilters = function () {
        var _this = this;
        this.isFiltersChanged = true;
        angular.forEach(this.jobMatchStates, function (val, key) {
            val.ticked = false;
        });
        angular.forEach(this.vendorsList, function (val, key) {
            val.ticked = false;
        });
        angular.forEach(this.outreachFilters, function (val, key) {
            val.ticked = false;
        });
        this.$timeout(function () {
            _this.globalQueryFilterObject = new JobMatchesQueryFilter();
        }, 100);
        //Reset Display Filter click events
        this.displaySelectedFilterContainer = { searchString: '', jobMatchStates: [], vendors: [], outreachStateFilters: [] };
        this.setSelectedFilterItems(this.displaySelectedFilterContainer);
    };
    CandidateJobMatchesWorkflowController.prototype.performActionMultiple = function (action) {
        var _this = this;
        var selectedCandidateJobMatches = [];
        if (this.selectAllJobMatchesFlag) {
            selectedCandidateJobMatches = angular.copy(this.allJobMatches);
            var unSelectedCandidateJobMatches = [];
            //get unselected candidates
            angular.forEach(this.candidatesObject, function (val, key) {
                angular.forEach(val.candidates, function (candidate, k) {
                    if (!candidate.selectedFlag) {
                        unSelectedCandidateJobMatches.push(candidate);
                    }
                });
            });
            //remove unselected candidates from selected candidates
            angular.forEach(unSelectedCandidateJobMatches, function (unSelectedJobMatch, key) {
                _.remove(selectedCandidateJobMatches, { jobMatchId: unSelectedJobMatch.jobMatchId });
            });
        }
        else {
            angular.forEach(this.candidatesObject, function (val, key) {
                angular.forEach(val.candidates, function (candidate, k) {
                    if (candidate.selectedFlag) {
                        selectedCandidateJobMatches.push(candidate);
                    }
                });
            });
        }
        if (action == "addCandidatesFromJobBoards" && !this.isJobBoardServiceUp) {
            this.alertsAndNotificationsService.showBannerMessage("Job Board Service is currently unavailable.", 'danger');
            return;
        }
        if (action == 'compareCandidates' && selectedCandidateJobMatches.length < 2) {
            bootbox.alert({
                closeButton: false,
                title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Too few Candidates Chosen</strong></div>",
                message: "Please select at least two candidates to compare.",
                className: "zIndex1060",
                buttons: {
                    ok: {
                        label: 'Ok',
                        className: 'btn-info'
                    }
                }
            });
        }
        else if (action == 'compareCandidates' && selectedCandidateJobMatches.length > 3) {
            bootbox.alert({
                closeButton: false,
                title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Too Many (" + selectedCandidateJobMatches.length + ") Candidates Chosen</strong></div>",
                message: "A maximum of 3 candidates can be compared at once. <br> Please choose 3 or fewer cards.",
                className: "zIndex1060",
                buttons: {
                    ok: {
                        label: 'Ok',
                        className: 'btn-info'
                    }
                }
            });
        }
        else if ((action == 'sendTechAssessment' || action == 'cancelTechAssessment' || action == 'sendValueAssessment' || action == 'cancelValueAssessment') && selectedCandidateJobMatches.length > 25) {
            var message = '';
            if (action == 'sendTechAssessment' || action == 'sendValueAssessment') {
                message = "A maximum of 25 candidates can be sent an assessment at once. <br> Please choose 25 or fewer cards.";
            }
            else if (action == 'cancelTechAssessment' || action == 'cancelValueAssessment') {
                message = "Assessment can be cancelled for a maximum of 25 candidates at once. <br> Please choose 25 or fewer cards.";
            }
            bootbox.alert({
                closeButton: false,
                title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Too Many (" + selectedCandidateJobMatches.length + ") Candidates Chosen</strong></div>",
                message: message,
                className: "zIndex1060",
                buttons: {
                    ok: {
                        label: 'Ok',
                        className: 'btn-info'
                    }
                }
            });
        }
        else if (action != 'addCandidates' && action != 'jobProfile' && action != 'associateCandidates' && action != 'compareCandidates' && action != 'addCandidatesFromJobBoards' && selectedCandidateJobMatches.length == 0) {
            bootbox.alert({
                closeButton: false,
                title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>No Cards Selected!</strong></div>",
                message: "Please select at least one card to perform this action.",
                className: "zIndex1060",
                buttons: {
                    ok: {
                        label: 'Ok',
                        className: 'btn-info'
                    }
                }
            });
        }
        else if (action == "sendCandidateOutreach" && selectedCandidateJobMatches.length > 0) {
            var windowClass = 'four-dot-five-modal-small';
            var validCandidatesToSendOutreachEmail_1 = [];
            var notValidCandidatesToSendOutreachEmail_1 = [];
            var selectedJobMatchesForOutreach_1 = [];
            var isSingleCandidateSelected_1 = false;
            var candidateId_1 = '';
            var candidateType_1 = '';
            selectedCandidateJobMatches.map(function (candidate, index) {
                var candidateFirstName = candidate.firstName ? candidate.firstName + " " : "";
                var candidateLastName = candidate.lastName ? candidate.lastName : "";
                var tempObject = {};
                tempObject.jobMatchId = candidate.jobMatchId;
                tempObject.candidateId = candidate.id;
                tempObject.workflowStepName = candidate.currentStep;
                tempObject.candidateName = candidate.candidateName = candidateFirstName + candidateLastName;
                tempObject.message = "";
                tempObject.selected = true;
                tempObject.candidateType = candidate.vendorName ? 'VENDOR_CANDIDATES' : 'OWN_CANDIDATES';
                if (!candidate.email || (candidate.currentStep == 'Released' || candidate.currentStep == 'Not Interested') || candidate.isOutreachDisabled) {
                    if (candidate.isOutreachDisabled) {
                        tempObject.message = "Outreach has already been Submitted.";
                    }
                    else if (candidate.currentStep == 'Released' || candidate.currentStep == 'Not Interested') {
                        tempObject.message = "Cannot Send Outreach to Candidates in '" + candidate.currentStep + "' State.";
                    }
                    else {
                        tempObject.message = "Email ID not available.";
                    }
                    notValidCandidatesToSendOutreachEmail_1.push(tempObject);
                }
                else {
                    validCandidatesToSendOutreachEmail_1.push(tempObject);
                    if (selectedCandidateJobMatches.length == 1) {
                        selectedJobMatchesForOutreach_1.push(tslib_1.__assign({}, candidate, tempObject));
                    }
                }
            });
            isSingleCandidateSelected_1 = selectedCandidateJobMatches.length == 1 && validCandidatesToSendOutreachEmail_1.length == 1 ? true : false;
            if (isSingleCandidateSelected_1) {
                selectedJobMatchesForOutreach_1[0].outreachActiveJob = true;
                selectedJobMatchesForOutreach_1[0].requisitionNumber = selectedJobMatchesForOutreach_1[0].jobMatchRequisitionNum;
                selectedJobMatchesForOutreach_1[0].jobTitle = selectedJobMatchesForOutreach_1[0].jobMatchTitle;
                selectedJobMatchesForOutreach_1[0].companyName = selectedJobMatchesForOutreach_1[0].clientOrBUName;
                selectedJobMatchesForOutreach_1[0].jobLocationText = this.jobMatchService.setJobLocationText(selectedJobMatchesForOutreach_1[0].jobLocation);
                selectedJobMatchesForOutreach_1[0].jobId = selectedJobMatchesForOutreach_1[0].jobMatchJobId;
                selectedJobMatchesForOutreach_1[0].candidateId = selectedJobMatchesForOutreach_1[0].id;
                windowClass = 'four-dot-five-modal-large';
                candidateId_1 = selectedJobMatchesForOutreach_1[0].id;
                candidateType_1 = selectedJobMatchesForOutreach_1[0].candidateType;
            }
            $(".modal").addClass("associate-candidate-modal");
            var label_1 = isSingleCandidateSelected_1 ? "Send outreach to Candidate <b>'" + selectedJobMatchesForOutreach_1[0].candidateName + "'</b>" : "Send outreach to Candidates";
            var vm_1 = this;
            this.sendOutreachEmailModal = this.$uibModal.open({
                animation: false,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                template: CandidateSendOutreachEmailModal.default,
                backdrop: 'static',
                windowTopClass: windowClass,
                controller: ['$uibModalInstance', 'label', 'validCandidatesToSendOutreachEmail', 'notValidCandidatesToSendOutreachEmail', 'isSingleCandidateSelected', 'companyId', 'userId', 'candidateId', 'clientOrBUId', 'candidateType', 'selectedJobMatchesForOutreach', 'context', 'salaryDurationOptions', 'jobTypeList',
                    function ($uibModalInstance, label, validCandidatesToSendOutreachEmail, notValidCandidatesToSendOutreachEmail, isSingleCandidateSelected, companyId, userId, candidateId, clientOrBUId, candidateType, selectedJobMatchesForOutreach, context, salaryDurationOptions, jobTypeList) {
                        var ctrl = this;
                        ctrl.label = label;
                        ctrl.validCandidatesToSendOutreachEmail = validCandidatesToSendOutreachEmail;
                        ctrl.notValidCandidatesToSendOutreachEmail = notValidCandidatesToSendOutreachEmail;
                        ctrl.isSingleCandidateSelected = isSingleCandidateSelected;
                        ctrl.companyId = companyId;
                        ctrl.userId = userId;
                        ctrl.candidateId = candidateId;
                        ctrl.clientOrBUId = clientOrBUId;
                        ctrl.candidateType = candidateType;
                        ctrl.selectedJobMatchesForOutreach = selectedJobMatchesForOutreach;
                        ctrl.context = context;
                        ctrl.salaryDurationOptions = salaryDurationOptions;
                        ctrl.jobTypeList = jobTypeList;
                        ctrl.closeModal = function () {
                            $uibModalInstance.close('cancel');
                        };
                        ctrl.saveCallback = function () {
                            if (isSingleCandidateSelected) {
                                ctrl.closeModal();
                                vm_1.resetCandidateJobMatches();
                            }
                            else {
                                var passedCandidateList_1 = [];
                                if (ctrl.validCandidatesToSendOutreachEmail.length > 0) {
                                    ctrl.validCandidatesToSendOutreachEmail.map(function (candidate) {
                                        if (candidate.selected) {
                                            passedCandidateList_1.push({
                                                id: candidate.candidateId,
                                                candidateType: candidate.candidateType,
                                                source: 'JOBMATCH_CARD',
                                                jobIds: [vm_1.jobId],
                                                jobMatchId: candidate.jobMatchId
                                            });
                                        }
                                    });
                                }
                                if (passedCandidateList_1.length > 0) {
                                    var outreachObject = {
                                        candidates: passedCandidateList_1,
                                        userId: vm_1.userId,
                                        companyId: vm_1.companyId,
                                        clientOrBuId: vm_1.jobInfo.clientOrBuId
                                    };
                                    vm_1.candidateService.sendOutreachEmail(outreachObject, function (data) {
                                        vm_1.alertsAndNotificationsService.showBannerMessage(data.message, 'success');
                                        ctrl.closeModal();
                                        vm_1.resetCandidateJobMatches();
                                    }, function (error) {
                                        ctrl.closeModal();
                                        vm_1.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                                    });
                                }
                                else {
                                    var title = "No candidates selected";
                                    var message_1 = "Please select atleast one candidate.";
                                    vm_1.alertsAndNotificationsService.showAlert(title, message_1, "warning");
                                }
                            }
                        };
                        ctrl.cancelCallback = function () {
                            ctrl.closeModal();
                        };
                    }],
                controllerAs: 'sendOutreachEmailModal',
                size: 'lg',
                resolve: {
                    validCandidatesToSendOutreachEmail: function () {
                        return validCandidatesToSendOutreachEmail_1;
                    },
                    notValidCandidatesToSendOutreachEmail: function () {
                        return notValidCandidatesToSendOutreachEmail_1;
                    },
                    label: function () {
                        return label_1;
                    },
                    isSingleCandidateSelected: function () {
                        return isSingleCandidateSelected_1;
                    },
                    companyId: function () {
                        return vm_1.companyId;
                    },
                    userId: function () {
                        return vm_1.userId;
                    },
                    candidateId: function () {
                        return candidateId_1;
                    },
                    clientOrBUId: function () {
                        return vm_1.jobInfo.clientOrBuId;
                    },
                    candidateType: function () {
                        return candidateType_1;
                    },
                    selectedJobMatchesForOutreach: function () {
                        return selectedJobMatchesForOutreach_1;
                    },
                    context: function () {
                        return 'candidateWorkflow';
                    },
                    salaryDurationOptions: function () {
                        return vm_1.salaryDurationOptions;
                    },
                    jobTypeList: function () {
                        return vm_1.jobTypeList;
                    }
                }
            });
        }
        else {
            var statusType = '';
            var windowTopClass = '';
            switch (action) {
                case 'release':
                    windowTopClass = 'four-dot-five-modal-large';
                    statusType = 'Release';
                    break;
                case 'notInterested':
                    windowTopClass = 'four-dot-five-modal-large';
                    statusType = 'Not Interested';
                    break;
                case 'delete':
                    windowTopClass = 'four-dot-five-modal-large';
                    statusType = 'Delete Job Match';
                    break;
                case 'addCandidates':
                    windowTopClass = 'four-dot-five-modal-large';
                    break;
                case 'addCandidatesFromJobBoards':
                    windowTopClass = 'four-dot-five-modal-large';
                    break;
                case 'associateCandidates':
                    windowTopClass = 'four-dot-five-modal-extra-large';
                    break;
                case 'sendTechAssessment':
                    windowTopClass = 'four-dot-five-modal-large';
                    break;
                case 'cancelTechAssessment':
                    windowTopClass = 'four-dot-five-modal-large';
                    break;
                case 'sendValueAssessment':
                    windowTopClass = 'four-dot-five-modal-large';
                    break;
                case 'cancelValueAssessment':
                    windowTopClass = 'four-dot-five-modal-large';
                    break;
                case 'compareCandidates':
                    windowTopClass = 'four-dot-five-modal-large';
                    if (selectedCandidateJobMatches.length == 3) {
                        windowTopClass = 'four-dot-five-modal-extra-large';
                    }
                    break;
                case 'jobProfile':
                    windowTopClass = 'four-dot-five-modal-large';
                    break;
            }
            var formalizeActivityPayload_1 = {
                candidate: null,
                requisition: new FormalizeRequisition(this.jobId, this.jobInfo.requisitionActualNumber, this.jobInfo.requisitionRole),
                jobMatch: new FormalizeJobMatch(null, this.jobId, this.jobInfo.requisitionActualNumber, this.jobInfo.requisitionRole),
                company: new FormalizeCompany(this.companyId, this.jobInfo.companyName, this.jobInfo.clientOrBuId, this.jobInfo.clientName)
            };
            var actionsModal = this.$uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: windowTopClass,
                component: 'candidateJobMatchesWorkflowActionsModal',
                resolve: {
                    jobMatchDetailsArray: function () {
                        var tempArray = [];
                        angular.forEach(selectedCandidateJobMatches, function (val, key) {
                            var tempObject = {};
                            tempObject.jobMatchId = val.jobMatchId;
                            tempObject.candidateId = val.id;
                            tempObject.workflowStepName = val.currentStep;
                            tempArray.push(tempObject);
                        });
                        return tempArray;
                    },
                    statusType: function () {
                        return statusType;
                    },
                    jobId: function () {
                        return _this.jobId;
                    },
                    clientOrBuId: function () {
                        return _this.jobInfo.clientOrBuId;
                    },
                    clientOrBuName: function () {
                        return _this.jobInfo.clientName;
                    },
                    isSharedRequisition: function () {
                        return _this.jobInfo.sharedRequisition;
                    },
                    corporateCompanyId: function () {
                        return _this.jobInfo.corporateId;
                    },
                    corporateCompanyName: function () {
                        return _this.jobInfo.corporateName;
                    },
                    lastAddedCandidateSourceTypeId: function () {
                        return _this.jobInfo.lastAddedCandidateSourceTypeId;
                    },
                    action: function () {
                        return action;
                    },
                    resumeRequiredForWorkflow: function () {
                        return _this.jobInfo.resumeRequiredForWorkflow;
                    },
                    formalizeActivityPayload: function () {
                        return formalizeActivityPayload_1;
                    }
                }
            });
            actionsModal.result.then(function (callbackObject) {
                $('.modal').css("overflow-y", "auto");
                if (callbackObject.callbackType == 'refresh') {
                    _this.resetCandidateJobMatches();
                }
            }, function (dismiss) {
                $('.modal').css("overflow-y", "auto");
                //do nothing;
            });
        }
    };
    CandidateJobMatchesWorkflowController.prototype.toggleColumn = function (workflowStep) {
        if (workflowStep.isCollapsedFlag) {
            workflowStep.isCollapsedFlag = false;
            this.$timeout(function () {
                workflowStep.showCollapseIconFlag = true;
                workflowStep.expandCollapseLabel = 'Collapse Column';
                workflowStep.countAndLabelTooltipPlacement = 'bottom-right';
            }, 600);
        }
        else {
            workflowStep.isCollapsedFlag = true;
            this.$timeout(function () {
                workflowStep.showCollapseIconFlag = false;
                workflowStep.expandCollapseLabel = 'Expand Column';
                workflowStep.countAndLabelTooltipPlacement = 'right';
            }, 600);
        }
    };
    CandidateJobMatchesWorkflowController.prototype.onFilterItemClick = function (selectedItems, label) {
        this.isFiltersChanged = true;
        switch (label) {
            case 'JobMatchStates':
                // set the selected job match states on the global query filter object
                this.globalQueryFilterObject.workflowStates = this.selectedJobMatchStates.map(function (val, index) {
                    return val.value;
                });
                this.displaySelectedFilterContainer.jobMatchStates = this.globalQueryFilterObject.workflowStates;
                this.displaySelectedFilterContainer.jobMatchStates = this.displaySelectedFilterContainer.jobMatchStates.filter(function (val) { return val !== undefined; });
                // Filter Duplicate Values
                this.displaySelectedFilterContainer.jobMatchStates = tslib_1.__spread(new Set(this.displaySelectedFilterContainer.jobMatchStates));
                this.setSelectedFilterItems(this.displaySelectedFilterContainer);
                break;
            case 'Vendors':
                // set the selected vendors' ids on the global query filter object
                this.globalQueryFilterObject.vendors = this.selectedVendors.map(function (val, index) {
                    return val.vendorId;
                });
                this.displaySelectedFilterContainer.vendors = this.selectedVendors.map(function (val, index) {
                    return val.vendorName;
                });
                this.setSelectedFilterItems(this.displaySelectedFilterContainer);
                break;
            case 'OutreachStates':
                this.globalQueryFilterObject.outreachStateFilters = this.selectedOutreachStates.map(function (val, index) {
                    return val.value;
                });
                this.displaySelectedFilterContainer.outreachStateFilters = this.selectedOutreachStates.map(function (val, index) {
                    return val.name;
                });
                this.setSelectedFilterItems(this.displaySelectedFilterContainer);
                break;
            default:
            //do nothing;
        }
    };
    CandidateJobMatchesWorkflowController.prototype.filterSelectRemoveAll = function (label, type) {
        this.isFiltersChanged = true;
        if (type == 'selectAll') {
            switch (label) {
                case 'JobMatchStates':
                    // set the selected job match states on the global query filter object
                    this.globalQueryFilterObject.workflowStates = this.jobMatchStates.map(function (val, index) {
                        return val.value;
                    });
                    this.displaySelectedFilterContainer.jobMatchStates = this.globalQueryFilterObject.workflowStates;
                    this.displaySelectedFilterContainer.jobMatchStates = this.displaySelectedFilterContainer.jobMatchStates.filter(function (val) { return val !== undefined; });
                    // Filter Duplicate Values
                    this.displaySelectedFilterContainer.jobMatchStates = tslib_1.__spread(new Set(this.displaySelectedFilterContainer.jobMatchStates));
                    this.setSelectedFilterItems(this.displaySelectedFilterContainer);
                    break;
                case 'Vendors':
                    // set the selected vendors' ids on the global query filter object
                    this.globalQueryFilterObject.vendors = this.vendorsList.map(function (val, index) {
                        return val.vendorId;
                    });
                    this.displaySelectedFilterContainer.vendors = this.vendorsList.map(function (val, index) {
                        return val.vendorName;
                    });
                    this.setSelectedFilterItems(this.displaySelectedFilterContainer);
                    break;
                case 'OutreachStates':
                    this.globalQueryFilterObject.outreachStateFilters = this.outreachFilters.map(function (val, index) {
                        return val.value;
                    });
                    this.displaySelectedFilterContainer.outreachStateFilters = this.outreachFilters.map(function (val, index) {
                        return val.name;
                    });
                    this.setSelectedFilterItems(this.displaySelectedFilterContainer);
                    break;
                default:
                //do nothing;
            }
        }
        else {
            switch (label) {
                case 'JobMatchStates':
                    // set the selected job match states to empty on the global query filter object
                    this.globalQueryFilterObject.workflowStates = [];
                    this.displaySelectedFilterContainer.jobMatchStates = [];
                    this.setSelectedFilterItems(this.displaySelectedFilterContainer);
                    break;
                case 'Vendors':
                    // set the selected vendors' ids to empty on the global query filter object
                    this.globalQueryFilterObject.vendors = [];
                    this.displaySelectedFilterContainer.vendors = [];
                    this.setSelectedFilterItems(this.displaySelectedFilterContainer);
                    break;
                case 'OutreachStates':
                    this.globalQueryFilterObject.outreachStateFilters = [];
                    this.displaySelectedFilterContainer.outreachStateFilters = [];
                    this.setSelectedFilterItems(this.displaySelectedFilterContainer);
                    break;
                default:
                //do nothing
            }
        }
    };
    CandidateJobMatchesWorkflowController.prototype.dropJobMatchCardCallback = function (draggableCandidate, droppingToStep) {
        var _this = this;
        this.jobMatchDragAndDropService.dropJobMatchCardToWorkflowStep(draggableCandidate, droppingToStep, this.workflowStepNames, function () {
            _this.resetCandidateJobMatches();
        });
    };
    CandidateJobMatchesWorkflowController.prototype.onDragStart = function (jobMatchToDrop) {
        if (this.jobMatchDragAndDropService.isMoveBackActionFromNotInterestedOrReleasedStep(jobMatchToDrop)) {
            var currentStep = jobMatchToDrop.currentStep;
            var stepToDropTo = jobMatchToDrop.availableActions.filter(function (action) {
                return action.actionType == "MOVE_BACKWARD";
            });
            this._removeDisallowedTypesFromSteps(currentStep, stepToDropTo[0]);
        }
    };
    CandidateJobMatchesWorkflowController.prototype._removeDisallowedTypesFromSteps = function (currentStepName, stepToDropTo) {
        var stepToDropToName = stepToDropTo.action.replace("Move back to ", "");
        angular.forEach(this.candidatesObject, function (step, stepKey) {
            if (step.workflowStep !== "Not Interested" && step.workflowStep !== "Released" && step.workflowStep !== stepToDropToName) {
                step.allowedDnDTypes = step.allowedDnDTypes.filter(function (type) {
                    return type !== currentStepName;
                });
            }
        });
    };
    CandidateJobMatchesWorkflowController.prototype.onDragEnd = function (jobMatchToDrop) {
        if (this.jobMatchDragAndDropService.isMoveBackActionFromNotInterestedOrReleasedStep(jobMatchToDrop)) {
            this._resetAllowedDndTypes();
        }
        this._clearIntervals();
    };
    CandidateJobMatchesWorkflowController.prototype._resetAllowedDndTypes = function () {
        var _this = this;
        angular.forEach(this.candidatesObject, function (workflowStep, key) {
            workflowStep.allowedDnDTypes = tslib_1.__spread(_this.jobMatchDragAndDropService.getAllowedDraggableTypesOfCurrentWorkflowStep(workflowStep.workflowStep, _this.workflowStepNames));
        });
    };
    CandidateJobMatchesWorkflowController.prototype._drag = function (e) {
        var _this = this;
        console.log('drag called');
        var isMoving = false;
        //Left
        if ((e.pageX - this.offset.left) <= this.distance) {
            isMoving = true;
            this._clearIntervals();
            this.intLeftHandler = setInterval(function () {
                _this.container.scrollLeft(_this.container.scrollLeft() - _this.step);
                console.log('left');
            }, this.timer);
        }
        //Right
        if (e.pageX >= (this.offsetWidth - this.distance)) {
            isMoving = true;
            this._clearIntervals();
            this.intRightHandler = setInterval(function () {
                _this.container.scrollLeft(_this.container.scrollLeft() + _this.step);
                console.log('right');
            }, this.timer);
        }
        //No events
        if (!isMoving) {
            this._clearIntervals();
        }
    };
    CandidateJobMatchesWorkflowController.prototype._clearIntervals = function () {
        clearInterval(this.intRightHandler);
        clearInterval(this.intLeftHandler);
        clearInterval(this.intTopHandler);
        clearInterval(this.intBottomHandler);
    };
    CandidateJobMatchesWorkflowController.prototype.getOutreachFilters = function () {
        var _this = this;
        this.outreachFiltersLoadedFlag = true;
        this.outreachService.getOutreachFilters(function (data) {
            _this.outreachFilters = data;
            if (_this.savedFilters && _this.savedFilters.outreachStateFilters && _this.savedFilters.outreachStateFilters.length > 0) {
                _this.selectedOutreachStates = _this.outreachFilters.filter(function (outreach) { return _this.savedFilters.outreachStateFilters.some(function (selected) { return selected == outreach.value; }); });
                _this.selectedOutreachStates.forEach(function (selected) {
                    selected.ticked = true;
                });
                _this.globalQueryFilterObject.outreachStateFilters = _this.selectedOutreachStates.map(function (val, index) {
                    return val.value;
                });
            }
            if (_this.savedDisplayedWorkflowSelectedFilter && _this.savedDisplayedWorkflowSelectedFilter.outreachStateFilters && _this.savedDisplayedWorkflowSelectedFilter.outreachStateFilters.length !== 0) {
                _this.displaySelectedFilterContainer.outreachStateFilters = [];
                _this.displaySelectedFilterContainer.outreachStateFilters = _this.selectedOutreachStates.map(function (val, index) {
                    return val.name;
                });
                _this.setSelectedFilterItems(_this.displaySelectedFilterContainer);
            }
            _this.outreachFiltersLoadedFlag = false;
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    CandidateJobMatchesWorkflowController.prototype.$onDestroy = function () {
        this.webSocketsService.resetWorkflowUpdateListener();
        this.removeJobMatchListener();
    };
    return CandidateJobMatchesWorkflowController;
}());
CandidateJobMatchesWorkflowController.$inject = ['$rootScope', '$state', '$uibModal', '$timeout', 'assessmentService', 'jobMatchDragAndDropService', 'requisitionService', 'companyService', 'jobMatchService', 'jobService', 'planService', 'webSocketsService', 'userRoleService', 'alertsAndNotificationsService', 'debounceService', 'browserService', 'candidateService', 'utilityService', 'outreachService', 'stateManagementStorageService'];
// import * as TEMPLATE from './candidate-job-matches-workflow.html';
import * as TEMPLATE from 'raw-loader!./candidate-job-matches-workflow.html';
export var CandidateJobMatchesWorkflowComponent = {
    selector: 'candidateJobMatchesWorkflow',
    component: {
        bindings: {
            jobId: '@',
            searchString: '@',
            globalQueryFilterObject: '<',
            reqStateData: '<'
        },
        controller: CandidateJobMatchesWorkflowController,
        template: TEMPLATE.default
        // templateUrl: "app/partials/missioncontrol/candidateJobMatchesWorkflow/candidateJobMatchesWorkflow/candidate-job-matches-workflow.html"
    }
};
//# sourceMappingURL=candidate-job-matches-workflow.component.js.map